import { Client, Frame } from '@stomp/stompjs';
import { Dispatch } from 'redux';
import { v4 as uuidv4 } from 'uuid';
import { RootState } from 'app/AppStore';
import { getToken } from 'domains/auth/Auth.util';
import { getWebLanguage } from 'domains/user';
import { getSelectedProfile } from 'domains/user/User.store';
import { checkAddSetIsExpired } from 'domains/webSockets/utils/utils';
import feVersion from 'VERSION.json';
import { setCollectingConnected } from '../WebSocket.store';

export const beforeConnectCollector = async (
  stompClient: Client,
  dispatch: Dispatch,
  getState: () => RootState,
): Promise<void> => {
  console.log('UserBehaviourMonitoring STOMP - before connect');
  const token = await getToken();
  const profile = getSelectedProfile(getState());
  const webLanguage = getWebLanguage(getState());

  if (!token || !profile) {
    await stompClient.deactivate();
    setTimeout(() => {
      stompClient.activate();
    }, 500);
    return;
  }

  stompClient.configure({
    connectHeaders: {
      'trace-id': uuidv4(),
      'x-auth-token': token,
      'selected-profile': profile.id,
      'app-version': feVersion.version,
      'web-language': webLanguage.toString(),
    },
  });

  const isExpired = await checkAddSetIsExpired(dispatch);
  if (isExpired) {
    dispatch(setCollectingConnected(false));
    await stompClient.deactivate();
  }
};

export const onConnect = (dispatch: Dispatch, frame: Frame): void => {
  console.log('UserBehaviourMonitoring STOMP - connection success', frame);
  dispatch(setCollectingConnected(true));
};

export const onDisconnect = (dispatch: Dispatch, frame: Frame): void => {
  console.warn('UserBehaviourMonitoring STOMP - disconnected', frame);
  dispatch(setCollectingConnected(false));
};

export const onStompError = (dispatch: Dispatch, frame: Frame): void => {
  console.error('UserBehaviourMonitoring STOMP - error', frame);
  dispatch(setCollectingConnected(false));
};

export const onWebSocketError = (dispatch: Dispatch, event: Event): void => {
  console.error('UserBehaviourMonitoring WebSocket - error', event);
  dispatch(setCollectingConnected(false));
};

export const onWebSocketClose = (dispatch: Dispatch, event: Event): void => {
  console.warn('UserBehaviourMonitoring WebSocket - closed', event);
  dispatch(setCollectingConnected(false));
};
